export default __webpack_public_path__ + "static/media/2.fbd10f99.png";